import DataRepo from '@api/datasource/data'
import LoaderText from '@components/shared/loader'
import QueryKeys from '@constants/queryKeys'
import { ModalProps } from '@customTypes/page'
import { useIsMobile } from '@hooks/mobile'
import { Badge, Modal, ScrollArea, Text, Timeline } from '@mantine/core'
import { IconGitCommit } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { isLoadingQuery } from '@utils/network'
import moment from 'moment'

const StatusUpdates = (props: ModalProps<string>) => {
  const { open, modal, data: clientId, size = 'lg', onClose: outerOnClose } = props

  const isMobile = useIsMobile()

  const statusHistory = useQuery({
    enabled: Boolean(clientId && open),
    queryKey: [QueryKeys.GET_STATUS_HISTORY_KEY, clientId],
    queryFn: async () => DataRepo.clientEntityService.getStatusHistory(clientId!),
  })

  const isLoading = isLoadingQuery(statusHistory)

  const content = (
    <div>
      {open && isLoading && <LoaderText>Cargando información del cliente</LoaderText>}
      {!isLoading && statusHistory.data && (
        <ScrollArea.Autosize mah={300}>
          <Timeline active={3} bulletSize={24}>
            {statusHistory.data.map((data) => (
              <Timeline.Item
                bullet={<IconGitCommit size={16} />}
                key={data.uid}
                title={
                  <Badge color={data.status.color} size="md">
                    {data.status.name}
                  </Badge>
                }
              >
                <Text size="md">{data.updateBy.displayName || data.updateBy.email}</Text>
                <Text c="dimmed" size="sm">
                  {moment(data.updatedAt).format('DD/MM/YYYY HH:mm:ss')}
                </Text>
              </Timeline.Item>
            ))}
          </Timeline>
        </ScrollArea.Autosize>
      )}
      {!isLoading && statusHistory.data && statusHistory.data.length === 0 && (
        <Text c="dimmed" size="sm">
          No hay historial de estados para este cliente.
        </Text>
      )}
    </div>
  )

  if (modal) {
    return (
      <Modal
        centered
        fullScreen={isMobile}
        opened={Boolean(open)}
        size={size}
        title="Historial de estados"
        onClose={onClose}
      >
        {content}
      </Modal>
    )
  }

  return content

  function onClose() {
    outerOnClose?.()
  }
}

export default StatusUpdates
